/* eslint-disable react/prop-types */

import React, { useState, useEffect } from 'react';

const DelayCalculator = ({ endDate, completedAt, status }) => {
  const [daysDelayed, setDaysDelayed] = useState(0);

  useEffect(() => {
    const currentDate = new Date();

    // Check if endDate is null
    if (endDate === null) {
      setDaysDelayed('N/A');
    } else {
      const endDateTime = new Date(endDate);
      let referenceDate = currentDate;

      // If the task is completed, use completedAt if provided, otherwise use endDate
      if (status.toLowerCase() === 'completed') {
        referenceDate = completedAt ? new Date(completedAt) : endDateTime;
      }

      if (referenceDate < endDateTime) {
        setDaysDelayed(0);
      } else {
        // Calculate the absolute difference in milliseconds between reference date and end date
        const timeDifference = Math.abs(endDateTime - referenceDate);
        const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

        // Update the state with the calculated days delayed
        setDaysDelayed(daysDifference);
      }
    }
  }, [endDate, completedAt, status]);

  return <span>{daysDelayed}</span>;
};

export default DelayCalculator;
